import React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

export default createSvgIcon(React.createElement(
  'g',
  null,
  React.createElement('path', {
    d: 'M29.8 9.4l-5.1-5.2c-.1-.1-.2-.2-.4-.2H13.6c-.7 0-1.4.2-1.9.7S11 5.9 11 6.6v1.5H9.6C8.2 8.1 7 9.3 7 10.7v17.7C7 29.8 8.2 31 9.6 31h13.8c1.4 0 2.6-1.2 2.6-2.6v-1.5h1.4c1.4 0 2.6-1.2 2.6-2.6V9.8c0-.2-.1-.3-.2-.4zm-5.5-3.8l4.1 4.2h-2.3c-.5 0-.9-.1-1.2-.4-.3-.3-.5-.8-.6-1.2V5.6zm.4 22.8c0 .7-.6 1.3-1.3 1.3H9.6c-.7 0-1.3-.6-1.3-1.3V10.7c0-.4.2-.7.4-.9.3-.2.6-.4.9-.4H11v14.9c0 .7.3 1.4.8 1.9s1.2.8 1.9.7h11.1l-.1 1.5zm2.7-2.8H13.6c-.3 0-.7-.1-.9-.4-.3-.2-.4-.6-.4-.9V6.6c0-.7.6-1.3 1.3-1.3h9.5v2.8c0 .8.3 1.6.9 2.2.6.6 1.3.9 2.1.8h2.6v13.1c0 .4-.2.7-.4 1-.2.3-.5.4-.9.4z',
    transform: 'translate(-2.653 -1.44)'
  }),
  React.createElement('path', {
    d: 'M25.3 15.3l-3.4-2c-.4-.3-.9-.3-1.3 0-.4.2-.7.7-.7 1.2V16h-5.2v1.3h5.2v1.2c0 .5.3 1 .7 1.2.4.3.9.3 1.4 0l3.4-2c.4-.3.7-.7.7-1.2-.1-.4-.4-.9-.8-1.2zm-.6 1.3l-3.4 2h-.1s-.1-.1 0-.1v-4-.1l3.4 2v.1s0 .1.1.1z',
    transform: 'translate(-2.653 -1.44)'
  })
));